import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { InvoiceStatusEnum } from "../../data/enums";

export namespace CustomerInvoiceValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Entries = defineValidation(
        defineRecordSchema({
            filters: v.object({
                status: v.optional(v.picklist(InvoiceStatusEnum.values)),
                minDate: v.optional(baseVals.isoDate()),
                maxDate: v.optional(baseVals.isoDate()),
            }),
        }),
    );

    export const Create = defineValidation(
        v.object({
            period: baseVals.isoDate("Periode"),
            customerId: baseVals.string(),
            subscriptionId: baseVals.string(),
        }),
    );

    export namespace API {
        export const Create = defineValidation(
            v.object({
                subscriptionId: baseVals.string(),
            }),
        );
    }
}
